export const MUT_GET_WALLETS = 'MUT_GET_WALLETS';
export const MUT_SET_WALLETS = 'MUT_SET_WALLETS';
export const MUT_ERR_WALLETS = 'MUT_ERR_WALLETS';
